// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".http-error[data-v-5435900d]{text-align:center;padding-top:60px;padding-bottom:40px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
